<template>
  <v-flex class="d-flex page-container">
    <v-navigation-drawer
      :mini-variant="miniVariant"
      :clipped="clipped"
      v-model="drawer"
      fixed
      app
    >
      <v-list>
        <template v-for="(item, i) in items">
          <v-list-tile 
            router
            :to="item.to"
            :key="i"
            :exact="(item.meta || {}).exact !== false"
            v-if="item.type === 'item'"
            @click="item.click ? item.click() : false"
          >
            <v-list-tile-action>
              <v-icon v-html="item.icon"></v-icon>
            </v-list-tile-action>
            <v-list-tile-content>
              <v-list-tile-title v-text="item.title"></v-list-tile-title>
            </v-list-tile-content>
          </v-list-tile>
          <v-list-tile
            v-else-if="item.type === 'subheader'"
            :key="i"
          >
            <v-list-tile-content>
              <v-list-tile-title :class="['subheader pa-0 grey--text text--darken-1 mt-3', item.class]">{{ item.title }}</v-list-tile-title>
            </v-list-tile-content>
          </v-list-tile>
          <v-divider
            v-else-if="item.type === 'divider'"
            dark
            class="my-4"
            :key="i"
          ></v-divider>
        </template>
      </v-list>
    </v-navigation-drawer>
    <v-toolbar fixed app :clipped-left="clipped" color="primary">
      <v-toolbar-side-icon @click="drawer = !drawer"></v-toolbar-side-icon>
      <!-- <v-btn 
        icon
        @click.stop="miniVariant = !miniVariant"
      >
        <v-icon v-html="miniVariant ? 'chevron_right' : 'chevron_left'"></v-icon>
      </v-btn>
      <v-btn
        icon
        @click.stop="clipped = !clipped"
      >
        <v-icon>web</v-icon>
      </v-btn>
      <v-btn
        icon
        @click.stop="fixed = !fixed"
      >
        <v-icon>remove</v-icon>
      </v-btn> -->
      <div class="d-flex align-center justify-center pa-1" style="width: 30px; height: 30px; background: rgba(255,255,255,0.95); border-radius: 100%;">
        <img src="/static/logo.png" class="fill-width fill-height">
      </div>
      <v-toolbar-title class="black--text">
        <span>{{ title }}</span>
        <span class="d-inline-block ml-1 body-1" v-if="appVersion !== null">v{{ appVersion }}</span>
      </v-toolbar-title>
      <v-spacer></v-spacer>
      <div class="no-select">
        <!-- <v-btn small @click="() => { user.name = user.role = 'ADMIN'; $store.commit('user/SET_USER', user); $router.go($route.name) }">ADMIN</v-btn>
        <v-btn small @click="() => { user.name = user.role = 'SUPERVISOR'; $store.commit('user/SET_USER', user); $router.go($route.name) }">SUPERVISOR</v-btn>
        <v-btn small @click="() => { user.name = user.role = 'DEVELOPER'; $store.commit('user/SET_USER', user); $router.go($route.name) }">DEVELOPER</v-btn>
        <v-btn small @click="() => { user.name = user.role = 'GUEST'; $store.commit('user/SET_USER', user); $router.go($route.name) }">GUEST</v-btn> -->
        <v-menu offset-y>
          <v-btn depressed color="primary" slot="activator">
            <v-avatar v-if="user['picture']" :size="32" class="mr-3">
              <img :src="user['picture']">
            </v-avatar>
            <v-icon v-else left dark>account_circle</v-icon>
            <div>
              <strong class="d-block" style="text-transform: none;">
                {{ user['name'] }}
              </strong>
              <span class="d-block text-xs-left" style="font-size: .75em; line-height: 1em; color: rgba(0, 0, 0, .65)">
                {{ user['role'] }}
              </span>
            </div>
          </v-btn>
          <v-list>
            <v-list-tile @click="signOut">
              <v-list-tile-action style="min-width: 0;margin-right: 1.5em;">
                <v-icon>power_settings_new</v-icon>
              </v-list-tile-action>
              <v-list-tile-title style="font-size: 0.875em;font-weight:500;">Sign Out</v-list-tile-title>
            </v-list-tile>
          </v-list>
        </v-menu>
      </div>
      <!-- <v-btn
        icon
        @click.stop="rightDrawer = !rightDrawer"
      >
        <v-icon>menu</v-icon>
      </v-btn> -->
    </v-toolbar>
    <v-content>
      <v-slide-y-transition mode="out-in">
        <router-view :key="$route.path"></router-view>
      </v-slide-y-transition>
    </v-content>
    <v-navigation-drawer
      temporary
      :right="right"
      v-model="rightDrawer"
      fixed
    >
      <v-list>
        <v-list-tile @click.native="right = !right">
          <v-list-tile-action>
            <v-icon light>compare_arrows</v-icon>
          </v-list-tile-action>
          <v-list-tile-title>Switch drawer (click me)</v-list-tile-title>
        </v-list-tile>
      </v-list>
    </v-navigation-drawer>
    <v-footer :fixed="fixed" app>
      <v-layout row justify-center>
        <span>&copy; yellow.com 2018</span>
      </v-layout>
    </v-footer>
  </v-flex>
</template>

<script>
  import appVersionChecking from './plugins/app-version'
  import { schemas } from './configs/schemas'
  import { titleText } from './libs/utils'
  import UserService from './services/user.service.js'
  import Highcharts from './libs/highcharts'

  export default {
    data () {
      let navItems = [
        { type: 'subheader', title: 'Pages' }
      ]
      const routes = this.$router.options.routes.find(r => r.path === '/').children.filter(r => {
        return r.meta.show !== false && UserService.hasPermission(r.meta.permission)
      }) || []
      routes.forEach(r => {
        navItems.push({
          ...r,
          type: 'item',
          icon: r.meta.icon,
          title: r.meta.title,
          to: r.name ? { name: r.name } : r.path
        })
      })
      /**
       * Collections
       */
      Object.keys(schemas).reverse().forEach(
        database => {
          let dbConfig
          switch (database) {
            case 'ARBITRAGE':
              dbConfig = {
                title: database,
                navTo: 'arbitrage-collection',
              }
              break;
            default:
              dbConfig = {
                title: 'Databases',
                navTo: 'collection',
              }
              break;
          }
          navItems.push(
            { type: 'subheader', title: dbConfig.title }
          )
          Object.keys(schemas[database]).forEach(
            collection => {
              if (UserService.hasPermission(dbConfig.navTo, collection)) {
                navItems.push({
                  type: 'item',
                  icon: 'mdi-database',
                  title: titleText(collection),
                  to: { name: dbConfig.navTo, params: { collection } }
                })
              }
            }
          )
        }
      )

      navItems = navItems.concat([
        { type: 'divider' },
        // { icon: 'settings', text: 'Settings' },
        { type: 'item', icon: 'power_settings_new', title: 'Sign Out', to: '#', click: this.signOut }
      ])

      return {
        user: this.$store.getters['user/user'],
        clipped: true,
        drawer: window.innerWidth >= 1264,
        fixed: false,
        items: navItems,
        miniVariant: false,
        right: true,
        rightDrawer: false,
        title: 'Yellow Dashboard',
        // app data
        schemas,
        // app-version
        appVersion: null,
        stopAppVersionChecking: null
      }
    },
    watch: {
      drawer () {
        // Fix `Highcharts` resize bug
        setTimeout(() => {
          $('[data-highcharts-chart]').toArray().forEach(e => {
            const index = $(e).data('highchartsChart')
            if (!isNaN(index)) {
              Highcharts.charts[index] && Highcharts.charts[index].reflow()
            }
          })
        }, 400)
      }
    },
    methods: {
      async signOut () {
        await UserService.logout()
        this.$router.replace({ name: 'signin' })
      }
    },
    beforeMount () {
      this.stopAppVersionChecking = appVersionChecking(({ build }) => {
        if (this.appVersion === null) {
          this.appVersion = build
        }
      })
    },
    beforeDestroy () {
      this.stopAppVersionChecking && this.stopAppVersionChecking()
    }
  }
</script>

<style lang="scss" scoped>
  .page-container {
    flex-direction: column;
  }
</style>
